import httpClient from './httpClient';

const API_BASE = '/api/bar-stock-quotes';

const barStockQuoteService = {
  async getQuotes(params = {}) {
    const response = await httpClient.get(API_BASE, { params });
    return response.data;
  },

  async getQuoteDates(params = {}) {
    const response = await httpClient.get(`${API_BASE}/quote-dates`, { params });
    return response.data;
  },

  async getQuote(id) {
    const response = await httpClient.get(`${API_BASE}/${id}`);
    return response.data;
  },

  async createQuote(data) {
    const response = await httpClient.post(API_BASE, data);
    return response.data;
  },

  async updateQuote(id, data) {
    const response = await httpClient.put(`${API_BASE}/${id}`, data);
    return response.data;
  },

  async deleteQuote(id) {
    const response = await httpClient.delete(`${API_BASE}/${id}`);
    return response.data;
  },

  async uploadQuoteFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await httpClient.post(`${API_BASE}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async importQuotes(items, replace = false, supplierName = '', quoteDate = '') {
    const response = await httpClient.post(`${API_BASE}/import`, {
      items,
      replace,
      supplier_name: supplierName,
      quote_date: quoteDate,
    });
    return response.data;
  },

  async deleteByDate(quoteDate) {
    const response = await httpClient.delete(`${API_BASE}/by-date`, {
      params: { quote_date: quoteDate },
    });
    return response.data;
  },
};

export default barStockQuoteService;
